<script>
	import { fade } from 'svelte/transition';
	export let data = {};
	import { director } from '$lib/directors.js';
	import Banner from '$lib/components/banner.svelte';
	import { resource } from '$lib/utils.js';
	import Icon from '@iconify/svelte';
	import { goto } from '$app/navigation';
	let directorMessage = data?.directorMessage[0];
</script>

<Banner name="Director's Message" />
<div class="flex flex-col justify-center items-center w-full" in:fade={{ duration: 1000 }}>
	<article
		class="w-[min(1860px,95%)] py-10 lg:py-20 gap-5 text-[rgba(0,0,0,0.7)] prose prose-sm sm:prose-base lg:prose-lg max-w-[75ch] prose-p:text-justify md:prose-p:text-[17px] prose-p:my-2 font-poppins flex flex-col"
	>
		<img
			src={resource(directorMessage?.field_poster?.field_media_image?.uri?.url)}
			alt={director[0].name ?? 'director'}
			class="object-cover w-full"
		/>
		<div class="text-justify prose-p:my-1 prose-p:text-justify">
			{@html directorMessage.body.processed}
		</div>
		<div class="text-left font-poppins">
			<p class="font-bold leading-3">{director[0].name ?? 'Fr. Dr. Jacob Mathew'}</p>
			<p>Sunday School Director, DSWA</p>
		</div>
	</article>
</div>

<button
	on:click={() => goto('/about/#director-message')}
	class="flex absolute top-5 left-6 z-50 justify-center items-center"
	><Icon
		icon="iconamoon:arrow-left-2-light"
		width="1.2em"
		height="1.2em"
		style="color: #ffc000"
	/></button
>
